const visible = ref(false)
const returnUrl = ref('')

let pendingOnConfirm = null

export function openLoginPrompt(options = {}) {
  if (visible.value) {
    return
  }

  returnUrl.value = options.returnUrl ?? ''
  pendingOnConfirm = typeof options.onConfirm === 'function'
    ? options.onConfirm
    : null
  visible.value = true
}

export function closeLoginPrompt() {
  visible.value = false
  returnUrl.value = ''
  pendingOnConfirm = null
}

export function consumeLoginPrompt() {
  const url = returnUrl.value
  const onConfirm = pendingOnConfirm
  closeLoginPrompt()
  return { returnUrl: url, onConfirm }
}

export function useLoginPrompt() {
  return {
    visible,
    open: openLoginPrompt,
    close: closeLoginPrompt,
    consume: consumeLoginPrompt,
  }
}
